import { render, staticRenderFns } from "./SelectSubject.vue?vue&type=template&id=71b844fa&"
import script from "./SelectSubject.vue?vue&type=script&lang=js&"
export * from "./SelectSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports